export default "__VITE_ASSET__CnhtDczy__"